<script>
import {queryOffice, testAccess, upsetPlatform} from "@/api/office";
import {Message} from "element-ui";

export default {
  name: 'Company',
  data(){
    return {
      officeId : null,
      info : {
        id : 1,
        platformPassword : 1111,
      },
      platformVisible : false,
      platform : {},
      platformRules : {
        platformAccount : [
          { required: true, message: '请输入市平台账号', trigger: 'blur' }
        ],
        platformPassword : [
          { required: true, message: '请输入市平台密码', trigger: 'blur' }
        ]
      },
      stbAccessVisible : false,
      stbResult : {},
    }
  },
  async mounted() {
    await this.getCacheOffice();
    this.fetchInfo()
  },
  methods: {
    async getCacheOffice(){
      const officeId = this.$route.query.id;
      console.log('officeId', officeId)
      if (officeId){
        this.officeId = officeId
        return Promise.resolve();
      }

      const user = localStorage.getItem('user')
      if ( user){
        this.officeId = JSON.parse(user).sysAccount.officeId
      }
      return Promise.resolve();
    },

    async fetchInfo(){
      if (this.officeId) {
        const resp = await queryOffice(this.officeId)
        if (resp && resp.code === "0000"){
          this.info = resp.result
        }
      }
    },

    // 保存市平台信息
    async fillPlatform(){
      const data = {
          ...this.platform,
          id : this.officeId
      }
      const resp = await upsetPlatform(data)
      if (resp && resp.code === "0000"){
        this.platformVisible = false
        Message.success('保存成功')
      }
      this.info.platformPassword = this.platform.platformPassword;
      this.info.platformAccount = this.platform.platformAccount;
    },

    openEdit (){
      this.platform = {
        platformPassword : this.info.platformPassword,
        platformAccount : this.info.platformAccount,
      }
      this.platformVisible = true
    },

    // 测试访问
    async testStbAccess(){
      const res = await testAccess(this.officeId)
      if (res && res.code === "0000"){
        this.stbResult = res.result
      }
      this.stbAccessVisible  = true
    }
  },

}
</script>

<template>
  <div>
    <div v-if="!info.id" class="app-container">
      <el-empty description="公司信息缺失" />
    </div>

    <div v-else style="display: flex; flex-direction: column; gap: 20px">
      <el-card>
        <el-descriptions title="企业信息" column="2">
          <el-descriptions-item label="企业名称">{{info.name || '-'}}</el-descriptions-item>
          <el-descriptions-item label="联系地址">{{info.address || '-'}}</el-descriptions-item>
          <el-descriptions-item label="注册时间">{{info.createdTime || '-'}}</el-descriptions-item>
        </el-descriptions>
      </el-card>

      <el-card>
        <el-descriptions title="市平台访问控制" :column="2">
          <div slot="extra">
            <el-row :gutter="10" type="flex">
              <el-button type="primary" size="mini" @click="openEdit">修改</el-button>
              <el-button type="primary" size="mini" :disabled="!info.platformPassword && !info.platformAccount" @click="testStbAccess">测试访问</el-button>
            </el-row>
          </div>
          <el-descriptions-item label="访问账号">{{ info.platformAccount || '未录入' }}</el-descriptions-item>
          <el-descriptions-item label="访问密码">
            {{ info.platformPassword || '未录入' }}
          </el-descriptions-item>
        </el-descriptions>
      </el-card>


    </div>

    <el-dialog title="修改信息" :visible.sync="platformVisible" width="600">
      <el-form :model="platform" label-width="120px" :rules="platformRules">
        <el-form-item label="访问账号" prop="platformAccount">
          <el-input v-model="platform.platformAccount" clearable />
        </el-form-item>

        <el-form-item label="访问密码" prop="platformPassword">
          <el-input v-model="platform.platformPassword" clearable show-password />
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="end">
        <el-button @click="platformVisible = false">取消</el-button>
        <el-button type="primary" @click="fillPlatform">保存</el-button>
      </el-row>
    </el-dialog>

    <el-dialog title="测试访问" :visible.sync="stbAccessVisible" width="600">
      <el-empty v-if="!stbResult.data" :description="stbResult.info" >
        <template slot="image">
          <i class="el-icon-error" style="font-size: 60px; color: red " />
        </template>
      </el-empty>
      <el-descriptions v-else title="访问成功" :column="2">
        <el-descriptions-item v-if="stbResult.data" label="token">{{ stbResult.data.data.token || '未录入' }}</el-descriptions-item>
        <el-descriptions-item v-if="stbResult.data" label="key">{{ stbResult.data.data.key || '未录入' }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>

  </div>

</template>

<style scoped>

</style>
